import { Badge, Button, Flex, Stack, Text } from '@mantine/core'
import { IconRefresh } from '@tabler/icons-react'
import { MRT_ColumnDef } from 'mantine-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getDatabaseStorage } from 'src/apis/settingAPI'
import TableComponent from 'src/components/TableComponent'
import { useModal } from 'src/context/ModalContext'
import { color, size } from 'src/variable/constant'

interface DatabaseStorageRow {
	no: number
	name: string
	total_size: string
	table_size: string
	index_size: string
	note: string
}

function DatabaseStoragePage() {
	const { openError } = useModal()
	const [data, setData] = useState<DatabaseStorageRow[]>([])
	const [loading, setLoading] = useState(false)

	const handleGetData = useCallback(async () => {
		setLoading(true)
		try {
			const res = await getDatabaseStorage()
			const rows = res?.data?.results?.object || []
			setData(
				rows.map((item, index) => ({
					...item,
					no: index + 1,
					name: item?.name || '',
					total_size: item?.total_size || '',
					table_size: item?.table_size || '',
					index_size: item?.index_size || '',
					note: item?.note || '',
				})),
			)
		} catch (error) {
			openError(error)
		} finally {
			setLoading(false)
		}
	}, [openError])

	const columns = useMemo<MRT_ColumnDef[]>(
		() => [
			{
				accessorKey: 'no',
				header: 'No',
				size: size.zero,
			},
			{
				accessorKey: 'name',
				header: 'Bảng/Index',
				size: size.long,
			},
			{
				accessorKey: 'total_size',
				header: 'Tổng dung lượng',
				size: size.text,
			},
			{
				accessorKey: 'table_size',
				header: 'Chỉ bảng',
				size: size.text,
			},
			{
				accessorKey: 'index_size',
				header: 'Chỉ index',
				size: size.text,
			},
			{
				accessorKey: 'note',
				header: 'Ghi chú',
				size: size.text,
				Cell: ({ cell }: any) =>
					cell.getValue() ? (
						<Badge color="orange" variant="light">
							{cell.getValue()}
						</Badge>
					) : (
						''
					),
			},
		],
		[],
	)

	useEffect(() => {
		handleGetData()
	}, [handleGetData])

	return (
		<Stack sx={{ width: '100%' }} spacing="md">
			<Flex align="center" justify="space-between" gap={16}>
				<Text fw={700} size="lg">
					DB Top Storage
				</Text>
				<Button
					leftIcon={<IconRefresh size={16} />}
					loading={loading}
					onClick={handleGetData}
					sx={{
						background: color.CmsPrimary,
						':hover': {
							background: `${color.CmsPrimary} !important`,
						},
					}}
				>
					Refresh
				</Button>
			</Flex>

			<TableComponent
				columns={columns}
				total={data.length}
				data={data}
				pagination={{ pageIndex: 1, pageSize: data.length || 30 }}
				loading={loading}
				enableRowActions={false}
				hidePagination
				handleChangePage={() => {}}
			/>
		</Stack>
	)
}

export default React.memo(DatabaseStoragePage)
